import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import Heading from '../../components/cms/heading'
import Copy from '../../components/cms/copy'
import ModuleContainer from '../../components/cms/module-container'
import CTA from '../../components/cms/cta'
import ButtonGroup from '../../components/cms/button-group'
import {useSlotRecipe} from '@chakra-ui/react3'
import copyOnlySlotRecipe from './index.recipe'

const CopyOnly = ({
    anchor,
    headingLevel,
    heading,
    copy,
    primaryCta,
    secondaryCta,
    alignment,
    background,
    spacing
}) => {
    const recipe = useSlotRecipe({recipe: copyOnlySlotRecipe})
    const styles = useMemo(() => recipe({alignment, spacing}), [recipe, alignment, spacing])

    return (
        <ModuleContainer
            anchor={anchor}
            background={background}
            css={styles.root}
            heading={heading}
        >
            <Heading {...heading} headingLevel={headingLevel} alignment={alignment}></Heading>

            {copy?.text && <Copy {...copy} alignment={alignment}></Copy>}
            {(primaryCta?.label || secondaryCta?.label) && (
                <ButtonGroup {...styles.buttonGroup}>
                    {primaryCta?.label && <CTA {...primaryCta} variant="primary" />}
                    {secondaryCta?.label && <CTA {...secondaryCta} variant="secondary" />}
                </ButtonGroup>
            )}
        </ModuleContainer>
    )
}

CopyOnly.propTypes = {
    anchor: PropTypes.string,
    headingLevel: PropTypes.number,
    heading: PropTypes.object,
    copy: PropTypes.object,
    primaryCta: PropTypes.object,
    secondaryCta: PropTypes.object,
    alignment: PropTypes.oneOf(['left', 'center']),
    background: PropTypes.oneOf(['default', 'subtle', 'strong', 'inverse']),
    spacing: PropTypes.oneOf(['default', 'reduced'])
}

export default CopyOnly
